import { useMutation } from "@tanstack/react-query";
import { createAcademicTerm as apiCreate } from "../../api/apiAcademicTerms";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateAcademicTerm() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: createAcademicTerm, isPending, data: results, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            navigate('/academic-terms');
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { isPending, error, createAcademicTerm, results };
}
